module.exports = __webpack_public_path__ + "static/img/form_logo.15d3a32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/form_logo.png
// module id = f4HS
// module chunks = 1